// 站点语言：跨路由共享。
// 首页用 useState 存语言，但 /privacy-policy、/terms 是独立路由的页面，
// 拿不到那份 state，所以切到中文后点页脚的法律条款会突然变成全英文。
// 这里把语言落到 localStorage，法律页在挂载时读同一份值。
const KEY = 'bizsprite-lang';

export const readLang = () => {
  try {
    const v = typeof localStorage !== 'undefined' ? localStorage.getItem(KEY) : null;
    return v === 'zh' ? 'zh' : 'en';
  } catch (e) {
    return 'en';
  }
};

export const writeLang = (l) => {
  try {
    if (typeof localStorage !== 'undefined') localStorage.setItem(KEY, l === 'zh' ? 'zh' : 'en');
  } catch (e) {
    /* 隐私模式下写不进去也不影响当前会话 */
  }
};
